import './styles/styles.scss';
import './twig/components/accordion/accordion';
import './twig/components/header/header';
import './twig/components/footer/footer';
import './twig/components/hero/hero';
import './twig/components/image-context/image-context';
import './twig/components/image-context-section/image-context-section';
import './twig/components/intro-context/intro-context';
import './twig/components/headline-carousel/headline-carousel';
import './twig/components/center-carousel/center-carousel';
import './twig/components/gallery-carousel/gallery-carousel';
import './twig/components/roulette-carousel/roulette-carousel';
import './twig/components/cta-divider/cta-divider';
import './twig/components/scrap-divider/scrap-divider';
import './twig/components/image-window/image-window';
import './twig/components/wide-image/wide-image';
import './twig/components/logo-section/logo-section';
import './twig/components/article-section/article-section';
import './twig/components/contact-section/contact-section';
import './twig/components/color-palette/color-palette';
import './twig/components/typography/typography';
import './twig/components/icons/icons';
import './twig/components/icon/icon';

console.log('Wasup');
